export const truncateAddress = (address) => {
  if (!address) return '?';
  const match = address.match(
    /^(0x[a-zA-Z0-9]{2})[a-zA-Z0-9]+([a-zA-Z0-9]{2})$/
  );
  if (!match) return address;
  return `${match[0].slice(0, 4)}…${match[0].slice(-2)}`;
};
